export default {
  name: 'RadioToggle',
  props: {
    modelValue: {
      type: [String, Number, Boolean],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    ariaLabel: {
      type: String,
      default: null,
    },
  },
  emits: ['update:modelValue', 'change', 'disabled-click'],
  computed: {
    resolvedAriaLabel() {
      return this.ariaLabel || this.$t('common.toggle');
    },
  },
  methods: {
    getOptionValue(option) {
      return option?.value ?? option?.key;
    },

    isDisabled(option) {
      return Boolean(option?.disabled);
    },

    getOptionTooltip(option) {
      return option?.tooltip ? { value: option.tooltip, class: 'tt-sm' } : null;
    },

    getOptionLabel(option) {
      return option?.labelKey ? this.$t(option.labelKey) : option?.label;
    },

    isActive(option) {
      return this.modelValue === this.getOptionValue(option);
    },

    selectOption(option) {
      const value = this.getOptionValue(option);
      if (this.isDisabled(option)) {
        this.$emit('disabled-click', value, option);
        return;
      }
      this.$emit('update:modelValue', value);
      this.$emit('change', value);
    },
  },
};
